import {
  Code,
  MusicNote,
  SportsEsports,
  SportsSoccer,
} from "@mui/icons-material";
import { Chip, Divider, Paper, Stack, Typography } from "@mui/material";
export default function Interests() {
  return (
    <Paper sx={{ p: 2 }}>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        <Typography>Interests</Typography>
        <Divider orientation="vertical" variant="middle" flexItem />
        <Chip icon={<Code />} label="Coding" />
        <Chip icon={<SportsEsports />} label="Game" />
        <Chip icon={<MusicNote />} label="Music" />
        <Chip icon={<SportsSoccer />} label="Football" />
      </Stack>
    </Paper>
  );
}
